import React, { useRef } from 'react';
import {
  Box,
  Paper,
  Button,
  IconButton,
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const VideoPlayerCard = ({ videoUrl, onGenerateAnother }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = React.useState(false);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        overflow: 'hidden',
        borderRadius: 2,
        width: { xs: '100%', md: '95%' },
        mx: 'auto',
        marginTop: { xs: 0, md: 3 },
        mb: { xs: 0, md: 3 },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          backgroundColor: 'black',
          aspectRatio: '16/9',
        }}
      >
        <video
          ref={videoRef}
          src={videoUrl}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
          controls
          controlsList="nodownload"
          onContextMenu={(e) => e.preventDefault()}
          onEnded={handleVideoEnd}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
        />

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            opacity: isPlaying ? 0 : 1,
            transition: 'opacity 0.3s',
            pointerEvents: isPlaying ? 'none' : 'auto',
          }}
        >
          <IconButton
            onClick={handlePlayPause}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
              },
              width: 64,
              height: 64,
            }}
          >
            {isPlaying ? (
              <PauseIcon sx={{ fontSize: 32 }} />
            ) : (
              <PlayArrowIcon sx={{ fontSize: 32 }} />
            )}
          </IconButton>
        </Box>
      </Box>

      {/* <Box sx={{ p: 3 }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          🎉 Your Video is Ready!
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Your AI-generated video has been created successfully. Download it or create another one.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Button
            variant="outlined"
            startIcon={<RestartAltIcon />}
            onClick={onGenerateAnother}
            fullWidth
            sx={{ py: 1.5 }}
          >
            Generate Another
          </Button>
        </Box>
      </Box> */}
    </Paper>
  );
};

export default VideoPlayerCard;
